import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GoogleTagManager = () => {
  
    const location = useLocation();
const gtmCode = window._env_?.GTMCode;
    useEffect(() => {
        setTimeout(() => {
            if (window.gtag) {
                window.gtag("config", gtmCode, {
                    page_path: location.pathname,
                });
                console.log("GTM reinitialized:", location.pathname);
            }
        }, 500); // Delay for GTM to register page change
    }, [location]);

    return null;
};

export default GoogleTagManager;
